import { render, staticRenderFns } from "./ccRecord.vue?vue&type=template&id=af59d162"
import script from "./ccRecord.vue?vue&type=script&lang=js"
export * from "./ccRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports